import React from "react";
import "./style.css";
import NavbarCustom from "../../Components/NavbarCustom";
import companyLogo from "../../Assets/Images/company_logo.png";
import { useNavigate } from "react-router-dom";

export const PaymentThankYou = () => {
  const navigate = useNavigate();

  const handleBackHome = () => {
    navigate("/session-sports?type=1-1");
  };

  return (
    <>
      <NavbarCustom />
      <div className="thankyou-container">
        <div className="thankyou-logo">
          <img src={companyLogo} alt="company_logo" />
        </div>
        <div className="thankyou-card">
          {/* <div className="thankyou-icon">✅</div> */}
          <h1 className="thankyou-title black-text-clip">Order Confirmed!</h1>
          <p className="thankyou-message black-text-clip">
            Thank you for your purchase. Your order has been successfully
            placed.
          </p>
          <button className="thankyou-button" onClick={handleBackHome}>
            Book Your Session
          </button>
        </div>
      </div>
    </>
  );
};
